export default __webpack_public_path__ + "static/media/kroller-muller.374ed46d.png";